// extracted by mini-css-extract-plugin
module.exports =  {"info":"info__GeOOs","rankingLoader":"rankingLoader__N4lWx"};